import { BlobDto } from "../../app/blobs.types";
import { coreApi } from "../../app/core-api";
import { EntityCreateResult, EntityUpdateResult, PagedResult, PagedSearchFilter } from "../../app/types";
import {
    PaymentVoucher,
    PaymentVoucherCreate,
    PaymentVoucherFilter,
    PaymentVoucherListItem,
    VoucherStatusChange,
} from "./voucher.types";

export const voucherApi = {
    searchVouchers,
    getVoucher,
    createVoucher,
    updateVoucher,
    deleteVoucher,
    getNextVoucherNumber,
    changeStatus,
    addAttachment,
    removeAttachment,
    getAttachments,
};

const controller = "vouchers";

function searchVouchers(filter: PagedSearchFilter<PaymentVoucherFilter>) {
    return coreApi.get<PagedResult<PaymentVoucherListItem>>(`${controller}/search`, {
        ...filter.filter,
        ...filter.pagination,
    });
}

function getVoucher(id: string) {
    return coreApi.get<PaymentVoucher>(`${controller}/${id}`);
}

function createVoucher(data: PaymentVoucherCreate) {
    return coreApi.post<EntityCreateResult>(controller, data);
}

function updateVoucher(id: string, data: PaymentVoucherCreate) {
    return coreApi.put<EntityUpdateResult>(`${controller}/${id}`, data);
}

function deleteVoucher(id: string) {
    return coreApi.remove(`${controller}/${id}`);
}

function getNextVoucherNumber() {
    return coreApi.get<number>(`${controller}/next-voucher-no`);
}

function changeStatus(id: string, data: VoucherStatusChange) {
    return coreApi.patch(`${controller}/${id}/status`, data);
}

function addAttachment(voucherId: string, blobId: string) {
    return coreApi.post<EntityCreateResult>(`${controller}/${voucherId}/attachments?blobId=${blobId}`, {});
}

function removeAttachment(voucherId: string, attachmentId: string) {
    return coreApi.remove(`${controller}/${voucherId}/attachments/${attachmentId}`);
}

function getAttachments(voucherId: string) {
    return coreApi.get<BlobDto[]>(`${controller}/${voucherId}/attachments`);
}
